import { render, staticRenderFns } from "./DocumentPreviewIFrame.vue?vue&type=template&id=57fc6038&scoped=true"
import script from "./DocumentPreviewIFrame.vue?vue&type=script&lang=js"
export * from "./DocumentPreviewIFrame.vue?vue&type=script&lang=js"
import style0 from "./DocumentPreviewIFrame.vue?vue&type=style&index=0&id=57fc6038&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fc6038",
  null
  
)

export default component.exports